/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import $ from 'jquery';
window.$ = window.jQuery = $;

import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/widgets/selectmenu.js';

// *********************************************************
// VUE.js
// *********************************************************


window.Vue = require('vue');

Vue.component(
    'example-component',
    require('./components/ExampleComponent.vue')
);

Vue.component(
    'passport-clients',
    require('./components/passport/Clients.vue')
);

Vue.component(
    'passport-authorized-clients',
    require('./components/passport/AuthorizedClients.vue')
);

Vue.component(
    'passport-personal-access-tokens',
    require('./components/passport/PersonalAccessTokens.vue')
);

const app = new Vue({
    el: '#app'
});

// *********************************************************
// SENTRY (error reporting)
// *********************************************************

import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: process.env.MIX_SENTRY_DSN,
  integrations: [new Sentry.Integrations.Vue({ Vue })]
})

// *********************************************************
// FUNCTIONS
// *********************************************************

/**
 * Enable a form group and select element
 * @param  g form group to be disabled [description]
 * @return void
 */
function groupEnable(g) {
  g.css("opacity", 1);
  g.css("pointer-events", "auto");
  g.children("select").prop("disabled", false);
  g.children("input").prop("disabled", false);
  g.children("textarea").prop("disabled", false);
}

/**
 * Disable a form group and select element
 * @param  g form group to be disabled [description]
 * @return void
 */
function groupDisable(g) {
  g.css("opacity", .4);
  g.css("pointer-events", "none");
  g.children("select").prop("disabled", true);
  g.children("input").prop("disabled", true);
  g.children("textarea").prop("disabled", true);
}

/**
 * Truncate a string with ellipsis
 */
String.prototype.capitalizeFirstLetter = String.prototype.capitalizeFirstLetter ||
function(n){
   return this.charAt(0).toUpperCase() + this.slice(1);
};

/**
 * Truncate a string with ellipsis
 */
String.prototype.trunc = String.prototype.trunc ||
function(n){
   return (this.length > n) ? this.substr(0, n-1) + '...' : this;
};

/**
 * Convert string to slug
 */
 String.prototype.slug = String.prototype.slug ||
function(str){
     str = str.replace(/^\s+|\s+$/g, ''); // trim
     str = str.toLowerCase();

     // remove accents, swap ñ for n, etc
     var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
     var to   = "aaaaeeeeiiiioooouuuunc------";
     for (var i=0, l=from.length ; i<l ; i++) {
         str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
     }

     str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
         .replace(/\s+/g, '-') // collapse whitespace and replace by -
         .replace(/-+/g, '-'); // collapse dashes

     return str;
 }

 String.prototype.capitalizeFirstLetter = String.prototype.capitalizeFirstLetter ||
function(str){
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// *********************************************************
// EASING FUNCTIONS
// *********************************************************
// t: current time, b: begInnIng value, c: change In value, d: duration
$.easing.jswing = $.easing.swing;

$.extend($.easing,
{
    def: 'easeOutQuad',
    swing: function (x, t, b, c, d) {
        //alert($.easing.default);
        return $.easing[$.easing.def](x, t, b, c, d);
    },
    easeInQuad: function (x, t, b, c, d) {
        return c*(t/=d)*t + b;
    },
    easeOutQuad: function (x, t, b, c, d) {
        return -c *(t/=d)*(t-2) + b;
    },
    easeInOutQuad: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t + b;
        return -c/2 * ((--t)*(t-2) - 1) + b;
    },
    easeInCubic: function (x, t, b, c, d) {
        return c*(t/=d)*t*t + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
        return c*((t=t/d-1)*t*t + 1) + b;
    },
    easeInOutCubic: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t + b;
        return c/2*((t-=2)*t*t + 2) + b;
    },
    easeInQuart: function (x, t, b, c, d) {
        return c*(t/=d)*t*t*t + b;
    },
    easeOutQuart: function (x, t, b, c, d) {
        return -c * ((t=t/d-1)*t*t*t - 1) + b;
    },
    easeInOutQuart: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
        return -c/2 * ((t-=2)*t*t*t - 2) + b;
    },
    easeInQuint: function (x, t, b, c, d) {
        return c*(t/=d)*t*t*t*t + b;
    },
    easeOutQuint: function (x, t, b, c, d) {
        return c*((t=t/d-1)*t*t*t*t + 1) + b;
    },
    easeInOutQuint: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
        return c/2*((t-=2)*t*t*t*t + 2) + b;
    },
    easeInSine: function (x, t, b, c, d) {
        return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
    },
    easeOutSine: function (x, t, b, c, d) {
        return c * Math.sin(t/d * (Math.PI/2)) + b;
    },
    easeInOutSine: function (x, t, b, c, d) {
        return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
    },
    easeInExpo: function (x, t, b, c, d) {
        return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
    },
    easeOutExpo: function (x, t, b, c, d) {
        return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
    },
    easeInOutExpo: function (x, t, b, c, d) {
        if (t==0) return b;
        if (t==d) return b+c;
        if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
        return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
    },
    easeInCirc: function (x, t, b, c, d) {
        return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
    },
    easeOutCirc: function (x, t, b, c, d) {
        return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
    },
    easeInOutCirc: function (x, t, b, c, d) {
        if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
        return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
    },
    easeInElastic: function (x, t, b, c, d) {
        var s=1.70158;var p=0;var a=c;
        if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
        if (a < Math.abs(c)) { a=c; var s=p/4; }
        else var s = p/(2*Math.PI) * Math.asin (c/a);
        return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
    },
    easeOutElastic: function (x, t, b, c, d) {
        var s=1.70158;var p=0;var a=c;
        if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
        if (a < Math.abs(c)) { a=c; var s=p/4; }
        else var s = p/(2*Math.PI) * Math.asin (c/a);
        return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
    },
    easeInOutElastic: function (x, t, b, c, d) {
        var s=1.70158;var p=0;var a=c;
        if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
        if (a < Math.abs(c)) { a=c; var s=p/4; }
        else var s = p/(2*Math.PI) * Math.asin (c/a);
        if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
        return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
    },
    easeInBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c*(t/=d)*t*((s+1)*t - s) + b;
    },
    easeOutBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
    },
    easeInOutBack: function (x, t, b, c, d, s) {
        if (s == undefined) s = 1.70158;
        if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
        return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
    },
    easeInBounce: function (x, t, b, c, d) {
        return c - $.easing.easeOutBounce (x, d-t, 0, c, d) + b;
    },
    easeOutBounce: function (x, t, b, c, d) {
        if ((t/=d) < (1/2.75)) {
            return c*(7.5625*t*t) + b;
        } else if (t < (2/2.75)) {
            return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
        } else if (t < (2.5/2.75)) {
            return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
        } else {
            return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
        }
    },
    easeInOutBounce: function (x, t, b, c, d) {
        if (t < d/2) return $.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
        return $.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
    }
});

function shrinkNav() {
  if ($(document).scrollTop() > 50) {
    $(".primary-nav").addClass("shrink");
  } else {
    $(".primary-nav").removeClass("shrink");
  }
}

// *********************************************************
// DOC READY
// *********************************************************

$(document).ready(function() {

  // Hack to disable CSS transitions until after page load
  // https://stackoverflow.com/a/24951743/3424316
  $("body").removeClass("preload");

  // Use jQuery UI selectmenu
  $('.narrow-select').selectmenu();

  /** When user scrolls down a bit, shrink the navar
  */
  shrinkNav();
  $(window).scroll(function() {
    shrinkNav();
  });

  /**
   * On login page, if the user has entered email and then clicks the forgot
   * password link, the following script will carry the user's email input
   * over to the next page.
   */
  if (window.location.pathname == "/login") {
    $(document).on("click", "a#reset-email", function(e) {
      // Disable page loading when link clicked
      e.preventDefault();
      // Fetch the current link
      var link = $(this).attr("href");
      // Append the contents of the email input
      var email = $("input#email").val();
      if (email !== "") {
        var newLink = link + "?email=" + email;
      } else {
        var newLink = link;
      }
      // Redirect the user to the new link
      window.location.assign(newLink);
    });
  };

  /**
   * For any checkbox input with the .group-toggle class:
   * If the checkbox is unchecked, disable immediate sibling input-group.
   */

  // Set initial disabled states as necessary
  $(".group-toggle").each(function(i) {
    var nextGroup = $(this).parent().parent().next().find(".group-toggle-target");
    if ($(this).prop("checked") == false) {
      groupDisable(nextGroup);
    }
  });

  $(document).on("click", ".group-toggle", function(e) {
    var nextGroup = $(this).parent().parent().next().find(".group-toggle-target");
    if ($(this).prop("checked")) {
      groupEnable(nextGroup);
    } else {
      groupDisable(nextGroup);
    }
  });

  /**
   * If we're on a high-density display, use the @2x image variant for images
   * with the "hires" class.
   */

   if (window.devicePixelRatio == 2) {

       var images = $("img.hires");

       // loop through the images and make them hi-res
       for (var i = 0; i < images.length; i++) {

         // create new image name
         var imageType = images[i].src.substr(-4);
         var imageName = images[i].src.substr(0, images[i].src.length - 4);
         imageName += "@2x" + imageType;

         //rename image
         images[i].src = imageName;
       }
     }

     /**
      * Article topic (tag) drawer controls
      *
      */

     $('.tag-drawer').each(function () {
       var target = $(this).siblings('.tag-cloud');
       var height = $(target).height();
       var scrollHeight = $(target)[0].scrollHeight;

       if (height >= scrollHeight-10) {
         $(this).hide();
       };
     })

     $('.tag-drawer').click(function () {

       var target = $(this).siblings('.tag-cloud');
       var height = $(target).height();
       console.log("height: " + height);
       var scrollHeight = $(target)[0].scrollHeight;

       if (height < scrollHeight) {
         console.log('height < scrollHeight');
         $(target).animate({
           height: scrollHeight
         }, 300, function() {
           console.log('show animation complete');
         });
         $(this).html('HIDE <i class="fa fa-chevron-up ml-1"></i>');
       } else {
         console.log('inside else');
         $(target).animate({
           height: '1.5em'
         }, 300, function() {
           console.log('hide animation complete');
         });
         $(this).html('SHOW ALL <i class="fa fa-chevron-down ml-1"></i>');
       }

     });

  require('./search');

});
